/** Clerk slug of the internal Edra organization. Mirrors the backend's
 * `EDRA_ORG_SLUG`; members of this org with `org:admin` are super-admins.
 * Kept here (no server-only imports) so it's safe to use from client code. */
export const EDRA_ORG_SLUG = "edra";
